import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
import { jsx as _jsx } from "react/jsx-runtime";
var PlaylistLinkIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/_jsx(BaseSvg, _objectSpread(_objectSpread({}, otherProps), {}, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden,
    children: /*#__PURE__*/_jsx("path", {
      d: "M4,12c0.002,0 1,0.021 1,1c-0,0.98 -1,1 -1,1l-1,0c0,0 -1,-0.014 -1,-1c-0,-0.985 0.998,-1 1,-1l1,0Zm-0,-4c0.002,0 1,0.021 1,1c-0,0.979 -0.998,1 -1,1l-1,0c0,0 -1,-0.014 -1,-1c-0,-0.985 0.998,-1 1,-1l1,0Zm-0,-4c0.002,0 1,0.021 1,1c-0,0.979 -0.998,1 -1,1l-1,0c0,0 -1,-0.014 -1,-1c-0,-0.985 0.998,-1 1,-1l1,0Z M11.374,8c-1.212,0.435 -2.232,1.153 -3.081,2l-1.293,0c0,0 -1,-0.014 -1,-1c-0,-0.985 0.998,-1 1,-1l4.374,0Zm2.578,0.663c0.031,0.097 0.048,0.209 0.048,0.337c-0,0.128 -0.017,0.24 -0.048,0.337l0,-0.674Zm1.048,-4.663c0.002,0 1,0.021 1,1c-0,0.979 -0.998,1 -1,1l-8,0c0,0 -1,-0.014 -1,-1c-0,-0.985 0.998,-1 1,-1l8,0Z M13.154,9.308c-4.736,0.029 -6.154,6.154 -6.154,6.154c1.23,-1.659 2.801,-3.056 6.154,-3.077l-0,2.307l3.846,-3.846l-3.846,-3.846l-0,2.308Z"
    })
  }));
});
PlaylistLinkIcon.displayName = 'PlaylistLinkIcon';
export default PlaylistLinkIcon;